//
// Action types
//

export const INITIALIZE_MAP = "INITIALIZE_MAP";

//
// Action creators
//

export function initializeMap(mapKey) {
  return { type: INITIALIZE_MAP, mapKey };
}

//
// Reducer and handlers
//

export function reduceMapInitialization(state) {
  return state || {};
}
